var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "fast-payment-system-modal",
      attrs: { visible: _vm.value },
      on: {
        "on-close": function($event) {
          return _vm.$emit("input", false)
        }
      }
    },
    [
      _c(
        "vue-client-only",
        [
          _vm.adaptive.isMobile
            ? _c("m-fast-payment-system", { attrs: { data: _vm.data } })
            : _c("d-fast-payment-system", { attrs: { data: _vm.data } })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }